module.exports = "<nb-card *ngIf=\"qrCodePhrase\">\n  <nb-card-header>\n    QR Code\n  </nb-card-header>\n  <nb-card-body>\n    <div #printSection class=\"qrcode-container\">\n      <qrcode [qrdata]=\"qrCodePhrase\" [size]=\"200\" [level]=\"'M'\"></qrcode>\n    </div>\n  </nb-card-body>\n  <!--\n  <nb-card-footer>\n    <button class=\"btn btn-primary-outline\" (click)=\"printQrCode()\">Print QR code</button>\n  </nb-card-footer>\n  -->\n</nb-card>\n<iframe id=\"printf\" name=\"printf\"></iframe>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/qrcode-card/qrcode-card.component.html
// module id = ./src/app/shared/qrcode-card/qrcode-card.component.html
// module chunks = main